const GRAPHQL_SUFFIX = "/GraphQLHandler";
const LEGACY_SUFFIX = "/query";
const DEFAULT_ORIGIN = "http://localhost:8080";

const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const normalizeEndpoint = (rawUrl) => {
  const sanitized = rawUrl?.trim();
  if (!sanitized) {
    return `${DEFAULT_ORIGIN}${GRAPHQL_SUFFIX}`;
  }

  if (sanitized.endsWith(GRAPHQL_SUFFIX)) {
    return sanitized;
  }

  if (sanitized.endsWith(LEGACY_SUFFIX)) {
    return `${sanitized.slice(0, -LEGACY_SUFFIX.length)}${GRAPHQL_SUFFIX}`;
  }

  return `${trimTrailingSlash(sanitized)}${GRAPHQL_SUFFIX}`;
};

const getGraphQLEndpoint = () => normalizeEndpoint(process.env.REACT_APP_BACKEND_URL);

export default getGraphQLEndpoint;
